module.exports = __webpack_public_path__ + "img/icon_sports_swimming.e86091bb.png";